import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { Col, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import LoadingButton from "../../../../../components/Loading/LoadingButton";
import { postRequestByAuth } from "../../../../../function/helper";
import styles from "./NewBankAccount.module.css";

function NewBankAccount({ onSubmit }) {
  const [showForm, setShowForm] = useState(false);

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();

  const { mutate, isPending } = useMutation({
    mutationKey: ["new-shaba-number"],
    mutationFn: body =>
      postRequestByAuth("/bank-account/v1/create", body).then(res => {
        if (res && res.status === 200) {
          Swal.fire({
            icon: "success",
            text: res.data.message,
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "green",
          }).then(() => {
            reset();
            setShowForm(false);
            onSubmit(res.data.data);
          });
          return;
        }

        Swal.fire({
          icon: "error",
          text: res.data.message,
          confirmButtonText: "متوجه شدم",
          confirmButtonColor: "red",
        });
      }),
  });

  return (
    <div className="mb-4">
      <button
        type="button"
        className="btn btn-secondary"
        onClick={() => setShowForm(cur => !cur)}
      >
        ایجاد حساب بانکی
      </button>

      <Modal show={showForm} centered size="lg" className={styles.modal}>
        <section className="d-flex flex-wrap row-gap-3 my-4 px-2">
          <Col xs={12} sm={6} lg={4} className="px-2">
            <Form.Label>نام صاحب حساب</Form.Label>
            <Form.Control
              {...register("name", {
                required: { value: true, message: "نام الزامی" },
              })}
            />
            {errors.name && (
              <p className="text-danger fs-small">{errors.name.message}</p>
            )}
          </Col>

          <Col xs={12} sm={6} lg={4} className="px-2">
            <Form.Label>نام خانوادگی صاحب حساب</Form.Label>
            <Form.Control {...register("lName")} />

            {errors.lName && (
              <p className="text-danger fs-small">{errors.lName.message}</p>
            )}
          </Col>

          <Col xs={12} sm={6} lg={4} className="px-2">
            <Form.Label>نام بانک</Form.Label>
            <Form.Control
              {...register("bankName", {
                required: { value: true, message: "نام بانک الزامی" },
              })}
            />

            {errors.bankName && (
              <p className="text-danger fs-small">{errors.bankName.message}</p>
            )}
          </Col>

          <Col xs={12} sm={6} className="px-2">
            <Form.Label>شماره ی شبا</Form.Label>
            <Form.Control
              {...register("shabaNumber", {
                required: { value: true, message: "شماره شبا الزامی" },
                minLength: {
                  value: 26,
                  message: "شماره شبا باید 24 رقم باشد و با IR شروع می‌شود",
                },
                maxLength: {
                  value: 26,
                  message: "شماره شبا باید 24 رقم باشد و با IR شروع می‌شود",
                },
              })}
            />

            {errors.shabaNumber && (
              <p className="text-danger fs-small">
                {errors.shabaNumber.message}
              </p>
            )}
          </Col>
        </section>
        <p className="fs-small px-2 mb-1">
          توجه داشته باشد که برای مبالغ COD مرسولات پرداخت در محل، نام صاحب حساب
          و فرستنده باید یکی باشد.
        </p>

        <Modal.Footer>
          {isPending && (
            <LoadingButton
              center
              className="btn-success"
              title="در حال ذخیره"
            />
          )}

          {!isPending && (
            <button
              type="button"
              onClick={handleSubmit(mutate)}
              className="btn btn-success text-center"
            >
              ذخیره
            </button>
          )}
          <button
            className="btn btn-danger"
            type="button"
            onClick={() => setShowForm(false)}
          >
            خروج
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default NewBankAccount;
